export default __webpack_public_path__ + "static/media/Screenshot 2023-09-13 at 1.36.34 PM.3bc1e8b7.png";